<section class="w-full flex flex-wrap">
  <article class="w-full flex flex-wrap">
    <!-- ? Page Header -->
    <app-header class="sticky top-0   z-30 bg-white dark:bg-gray-900 shadow-sm" [_Config]="headerConfig">
    </app-header>

    <!-- ? Books Count Progress -->
    <ng-container *ngIf="!loadingNextAchievement; else SkeletonNextAchievementTemplate">
      <div class="w-full mt-4 px-4">
        <!-- ? Achievement Info -->
        <div class="w-full flex justify-between items-center">
          <div>
            <span class="text-green-500 text-sm">{{ nextAchievementStep.readBooksCount }} کتاب</span>
            <ng-container *ngIf="nextAchievementStep.nextAchievementStep > 0">
              /
              <span class="text-gray-500 text-sm">{{ nextAchievementStep.nextAchievementStep }} کتاب</span>
            </ng-container>
          </div>
          <ng-container *ngIf="nextAchievementStep.remainingAchievementBooks > 0">
            <span class="text-gray-500 text-sm">{{ nextAchievementStep.remainingAchievementBooks }} کتاب تا
              دستاورد بعدی</span>
          </ng-container>
        </div>

        <!-- ? Achievement Progress Bar -->
        <div class="w-full flex flex-wrap items-center mt-1 h-[14px] relative rounded-sm bg-green-50 mb-4" dir="rtl">
          <div class="h-[14px] absolute max-w-full rounded-sm bg-green-500" [ngStyle]="{
              width: (
                nextAchievementStep?.nextAchievementStep -
                  nextAchievementStep?.lastAchievedStep
                | progressWidth : progressBarStep
              ).stylePersent
            }"></div>
        </div>
      </div>
    </ng-container>

    <!-- ? Achievement Flow -->
    <div class="w-full flex flex-wrap mt-4 px-4" [ngClass]="{ 'achievements-flow': profileOwner }">
      <p class="text-base text-gray-500 mb-4">روند دستاوردها</p>
      <ng-container *ngIf="!loadingAllAchievements; else SkeletonAllAchievementTemplate">
        <ng-container *ngFor="let stage of allAchievements">
          <div class="w-full flex items-center p-2 mb-4 relative shadow rounded-md text-gray-50"
            [ngClass]="{ disabled: !stage?.hasAchieved }">
            <div class="absolute left-0 -top-[14px] -rotate-[20.61deg] text-gray-200">
              <span *ngIf="!stage?.hasAchieved" class="icon text-sm lock-closed-regular"></span>
            </div>
            <img width="36px" height="36px" class="object-fill" [src]="
                stage?.id
                  | image : imageType.achivment : stage?.hasPhoto : '.svg'
              " />



            <span class="text-xs font-medium text-gray-700 mr-2">{{
              stage?.title
              }}</span>

            <span class="text-xs text-gray-700">
              <span class="mr-1 text-gray-700">-</span>
              {{ stage?.description }}
            </span>

            <!-- <span *ngIf="stage?.hasAchieved" class="text-xs text-gray-700">{{
              stage?.description
              }}</span>
            <span *ngIf="!stage?.hasAchieved" class="text-xs text-gray-700">{{
              stage?.description
              }}</span> -->
          </div>
        </ng-container>
      </ng-container>
    </div>
  </article>
  <!-- <article class="left-article">
    <app-home-currently-reading></app-home-currently-reading>
  </article> -->
</section>

<ng-template #SkeletonNextAchievementTemplate>
  <div class="w-full mt-4 px-4">
    <!-- ? Info Skeleton -->
    <div class="w-full flex justify-between items-center">
      <ngx-skeleton-loader [theme]="{ height: '24px', width: '84px' }">
      </ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '24px', width: '120px' }">
      </ngx-skeleton-loader>
    </div>

    <!-- ? Progress Bar Skeleton -->
    <div class="w-full mt-1 mb-4" dir="rtl">
      <ngx-skeleton-loader [theme]="{ height: '15px', width: '100%' }">
      </ngx-skeleton-loader>
    </div>
  </div>
</ng-template>

<ng-template #SkeletonAllAchievementTemplate>
  <div class="w-full mb-4">
    <ngx-skeleton-loader [theme]="{ height: '360px', width: '100%' }">
    </ngx-skeleton-loader>
  </div>
</ng-template>